import { LayoutHeaderMenu } from '../../../features/Layout/components/LayoutHeaderMenu/LayoutHeaderMenu'
import { AdminProfile } from '../admin-profile/AdminProfile'

export const AdminHeaderContent = () => {
  return (
    <>
      <LayoutHeaderMenu />
      <AdminProfile />
    </>
  )
}
